<template>
	<v-expansion-panel>
		<v-expansion-panel-header expand-icon="" color="secondary">
			<v-toolbar rounded color="secondary" elevation="0" :outlined="false" dense class="pt-0 pb-0 mr-0 ml-0 font-weight-bold white--text justify-center text-center"
				><v-spacer></v-spacer><v-toolbar-title class="justify-center text-center" style="font-size: 32px">{{ title }}</v-toolbar-title
				><v-spacer></v-spacer
			></v-toolbar>
		</v-expansion-panel-header>
		<v-expansion-panel-content class="mx-auto justify-center text-center ml-5 mr-5 mt-5">
			<v-card-text class="justify-center text-center">
				<v-row class="justify-left text-center">
					<v-col v-for="(val, key) in company.address" :key="'Address:' + key" cols="4">
						<v-text-field
							outlined
							:append-icon="readonly['Address:' + key] ? 'mode_edit' : 'done'"
							:readonly="readonly['Address:' + key]"
							:label="key"
							:v-model="company.address[key]"
							:value="company.address[key]"
							@click:append="readonly['Address:' + key] ? edit('Address:' + key) : finished('Address:' + key)"
						></v-text-field>
					</v-col>
					<v-col cols="4">
						<v-tooltip bottom>
							<template #activator="{ on, attrs }">
								<v-btn x-large block color="primary" v-bind="attrs" v-on="on">Google Map</v-btn>
							</template>
							<span>Not yet implemented.</span>
						</v-tooltip>
					</v-col>
				</v-row>
			</v-card-text>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>
export default {
	name: 'AdminViewPracticeAddressCard',
	components: {},
	props: {
		company: { type: Object, optional: false, required: true },
	},
	data: () => ({
		title: 'Address',
		readonly: {},
	}),
	mounted() {
		this.$nextTick(() => {
			Object.keys(this.company.address).forEach(addrKey => {
				this.readonly['Address:' + addrKey] = true;
				this.finished('Address:' + addrKey);
			});
		});
	},
	methods: {
		edit(key) {
			Object.keys(this.readonly)
				.filter(k => k != key && !this.readonly[k])
				.forEach(k => this.finished(k));
			this.readonly[key] = false;
			this.$forceUpdate();
		},
		finished(key) {
			if (Object.keys(this.readonly).find(k => k == key)) {
				this.readonly[key] = true;
			} else {
				console.error("unknown readonly key '" + key + "'");
			}
			this.$forceUpdate();
		},
	},
};
</script>
